class PredictiveSearch extends HTMLElement {
	constructor() {
		super();

		this.input = this.querySelector('input[type="search"]');
		this.predictiveSearchResults = this.querySelectorAll('.predictive-search');

		this.input.addEventListener('input', this.debounce((event) => {
			if (this.input.value.length > 0) {
				document.querySelectorAll('.mmSearchClear > svg').forEach(function(svg) {
					svg.style.opacity = '1';
				});
			} else {
				document.querySelectorAll('.mmSearchClear > svg').forEach(function(svg) {
					svg.style.opacity = '0';        
				});
			}
			
			this.onChange(event);
		}, 300).bind(this));
	}

	onChange() {
		const typedTerm = this.input.value.trim();
		// « osb3 » → « osb 3 », « bastaing » → « poutre » : voir mm_search_rewrite.js
		const searchTerm = window.SearchRewriteManager ? window.SearchRewriteManager.rewrite(typedTerm) : typedTerm;

		if (!searchTerm.length) {
			this.close();
			return;
		}

		this.getSearchResults(searchTerm);
	}

	getSearchResults(searchTerm) {
		fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
			.then((response) => {
                // console.log('response :', response);
				if (!response.ok) {
					var error = new Error(response.status);
					this.close();
					throw error;
				}

				return response.text();
			})
		.then((text) => {
			const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
			this.predictiveSearchResults.forEach(result => {
				result.innerHTML = resultsMarkup;
			});
			productCardsSlider()
			searchSplideProducts();

			this.open();
		})
		.catch((error) => {
			this.close();
			throw error;
		});
	}

	open() {
		this.predictiveSearchResults.forEach(result => {
			result.style.display = 'block';
		});
		document.querySelector('.mm-header-bg-filter')?.classList.add('mm-visible');
	}

	close() {
		this.predictiveSearchResults.forEach(result => {
			result.style.display = 'none';
		});
		document.querySelector('.mm-header-bg-filter')?.classList.remove('mm-visible');
	}

	debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}
}

customElements.define('predictive-search', PredictiveSearch);
